class DynamicLinkEditPageController {

  constructor($state, AlertService, DynamicLinkService, LoaderService, Upload) {
    this.$state = $state;
    this.AlertService = AlertService;
    this.DynamicLinkService = DynamicLinkService;
    this.LoaderService = LoaderService;
    this.Upload = Upload;
  }

  $onInit() {
    var self = this;
    this.id = this.$state.params.id;
    self.files = [];
    self.countFileUploaded = 0;
    self.imageEndpoint = "/api/upload";
    self.validation = {};
  }

  storeFile(picFile) {
    this.files.push(picFile);
  }


  save() {
    var self = this;

    if (!self.validForm()) {
      self.AlertService.error("The form has validation errors.");
      return;
    }

    self.LoaderService.start();
    self.DynamicLinkService.updateDynamicLink(self.dynamicLink, self.files[0])
      .then(() => {
        // empty the file array
        self.files.splice(0, self.files.length);
        self.AlertService.success("Dynamic link has been updated");
        self.$state.go('app.moreItems.dynamicLinks', {}, { reload: true });
      }
      )
      .catch((error) => {
        if (error.type === 'image') {
          self.validation = {};
          self.validation.headerImage = error.message;
          self.AlertService.error("The form has validation errors.");
          // empty the file array
          self.files.splice(0, self.files.length);
        }
        else {
          self.AlertService.error("There was a problem saving the dynamic link");
        }
      })
      .finally(() => {
        self.LoaderService.stop();
      });
  }

  deleteDynamicLink(dynamicLinkId) {
    if (confirm("Are you sure? This cannot be undone.")) {
      var self = this;
      self.LoaderService.start();
      self.DynamicLinkService.deleteDynamicLink(dynamicLinkId)
        .then(() => {
          self.AlertService.success("The dynamic link was deleted");
          self.$state.go('app.moreItems.dynamicLinks', {}, { reload: true });
        })
        .catch((error) => self.AlertService.error("There was a problem deleting the dynamic link"))
        .finally(() => self.LoaderService.stop());
    }
  }

  validForm() {
    var self = this;
    //validation

    self.validation = {};

    if (self.dynamicLink.name === undefined || self.dynamicLink.name === '') {
      self.validation.name = 'Name is required';
    }
    if (self.dynamicLink.url === undefined || self.dynamicLink.url === '') {
      self.validation.url = 'URL is required';
    } else if (self.dynamicLink.url.length > 0 && !self.dynamicLink.url.startsWith("http://") && !self.dynamicLink.url.startsWith("https://")) {
      self.validation.url = 'Please ensure URL starts with http:// or https://';
    }

    if (self.isEmpty(self.validation)) {
      return true;
    }
    else {
      return false;
    }

  }

  isEmpty(obj) {

    // null and undefined are "empty"
    if (obj == null) return true;

    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0) return false;
    if (obj.length === 0) return true;

    // If it isn't an object at this point
    // it is empty, but it can't be anything *but* empty
    // Is it empty?  Depends on your application.
    if (typeof obj !== "object") return true;

    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    for (var key in obj) {
      if (hasOwnProperty.call(obj, key)) return false;
    }

    return true;
  }

}
DynamicLinkEditPageController.$inject = ['$state', 'AlertService', 'DynamicLinkService', 'LoaderService', 'Upload'];
export default DynamicLinkEditPageController;
